import { readBooks } from "./bookState";

export function calcSimilarity(myBookIds, theirBookIds) {
  if (!myBookIds || myBookIds.length === 0 || !theirBookIds || theirBookIds.length === 0) return 0;
  const shared = myBookIds.filter(id => theirBookIds.includes(id));
  return Math.round((shared.length / myBookIds.length) * 100);
}

/**
 * getMergedFriendIds — autoFriends + myFriends + 나를 추가한 유저 → 통합 친구 ID Set
 */
export function getMergedFriendIds(autoFriends, myFriends, users, myId) {
  const ids = new Set();
  (autoFriends || []).forEach(f => ids.add(f.id));
  (myFriends || []).forEach(id => ids.add(id));
  if (myId) {
    (users || []).forEach(u => {
      if (u.id !== myId && (u.manualFriends || []).includes(myId)) ids.add(u.id);
    });
  }
  ids.delete(myId);
  return ids;
}

export function getAutoFriends(myBooks, users, myUid) {
  // 담아두기만 한 책으로 이웃이 되면 안 된다.
  const myBookIds = readBooks(myBooks, myUid).map(b => b.id);
  return (users || [])
    .filter(r => r.id !== myUid)
    .map(r => ({ ...r, similarity: calcSimilarity(myBookIds, r.bookIds || []) }))
    .filter(r => r.similarity >= 30)
    .sort((a, b) => b.similarity - a.similarity);
}
